/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-04-16 18:13:36
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-05-17 15:07:49
 * @Description: 
 */
import qs from "qs";
import api from "@/api/rushi-h5-platform"
import myAxios from "./interceptors"
let axios = new myAxios();
let _options = {
  borrowOpenid: '',
  borrowPassport: ''
};
const Mock = require('mockjs');
// Add a request interceptor
axios.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.log("http interceptors by rushi-h5-platform");
  config.url = `${api.protocol}//${api.domain}/qc-webapp/wxapi.do`;
  config.headers = {
    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
  }
  // console.log("config", config);
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// Add a response interceptor
axios.axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if (response.config.headers.res) {
    switch (response.config.headers.res) {
      case 'data':
        if (response.data) {
          response = response.data;
        }
        break;
      case 'data2':
        if (response.data && response.data.hasOwnProperty('data')) {
          response = response.data.data;
        } else {
          return Promise.reject(response);
        }
        break;
      default:
        break;
    }
  }
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});

export default {
  options: _options,
  qs: qs,
  getMock(url, param, addParam) {
    if (typeof url == "object" && url.mock) {
      Mock.mock(new RegExp(`${api.protocol}//${api.domain}${url.api}` + "?."), 'get', url.mock);
    } else {
      throw new Error("没有配置mock数据");
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "get",
        url: realUrl,
        params: param,
        headers: addParam
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  get(url, param, addParam) {
    if (process.env.VUE_APP_MOCK == 1) {
      if (typeof url == "object" && url.mock) {
        Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'get', url.mock);
      } else {
        console.warn(`已启动全局mock，但 ${url} 没有配置mock数据，请留意`);
      }
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    let obj = {
      openid: _options.borrowOpenid,
      passport: _options.borrowPassport,
      vericode: "",
      url: location.href,
      action: param.action,
      requestParam: param.requestParam || {}
    };
    let params = {
      j: JSON.stringify(obj),
      t: Math.ceil(Math.random() * 1000)
    };

    return new Promise((resolve, reject) => {
      axios.axios({
        method: "get",
        url: realUrl,
        params: params,
        headers: addParam
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  postMock(url, param, addParam) {
    if (typeof url == "object" && url.mock) {
      Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'post', url.mock);
    } else {
      throw new Error("没有配置mock数据");
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "post",
        url: realUrl,
        data: param,
        headers: addParam
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  post(url, param, addParam) {
    if (process.env.VUE_APP_MOCK == 1) {
      if (typeof url == "object" && url.mock) {
        Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'post', url.mock);
      } else {
        console.warn(`已启动全局mock，但 ${url} 没有配置mock数据，请留意`);
      }
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "post",
        url: realUrl,
        data: qs.stringify(param),
        headers: addParam
      })
        .then(res => {
          resolve(res);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
